import React from "react";

import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

import { collectionToStories, Link } from "@quintype/components";

import { StoryCard } from "../../Molecules/StoryCard";
import { CollectionName } from "../../Atoms/CollectionName";
import { generateNavigateSlug, getSlug, navigateTo } from "../../../utils/utils";
import { LoadmoreButton } from "../../Atoms/Loadmore";
import { Button, SvgIconHandler } from "../../../../components/atoms";
import { getCategoryAndSubCategory } from "../../../../ga-utils";
import { getTemplateName } from "../../../../components/utils";

import "./lifestyle-row.m.css";
import { useDeviceType } from "../../../../components/customHooks/useDeviceType";

const LifestyleRow = ({ collection, config, page = "" }) => {
  const stories = collectionToStories(collection);
  const { collectionNameTemplate = "", collectionNameBorderColor = "" } = config;
  const dispatch = useDispatch();
  const url = generateNavigateSlug(collection, {});

  const pushDataLayerEvent = (position) => {
    if (typeof window !== "undefined" && window.dataLayer) {
      const { category, subCategory, contentId } = getCategoryAndSubCategory(window.location, page);
      window.dataLayer.push({
        event: "dl_story_listing_component_click",
        link_position: position,
        section_name: collection?.name?.toLowerCase(),
        category: category,
        sub_category: subCategory,
        content_id: contentId,
        template_name: getTemplateName(page),
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
      });
    }
  };

  const handleCollectionNameClick = () => {
    pushDataLayerEvent(-2);
    navigateTo(dispatch, url);
  };

  const handleReadMoreClick = () => {
    pushDataLayerEvent(-1);
    navigateTo(dispatch, url);
  };

  const handleStoryClick = (position) => {
    pushDataLayerEvent(position + 1); // +1 to convert from 0-indexed to 1-indexed
  };

  const renderStoryCards = (stories) => {
    return stories.map((story, idx) => (
      <div styleName="desktop-story-card" key={story.id || idx} onClick={() => handleStoryClick(idx)}>
        <StoryCard story={story} config={config} headerLevel={3} aspectRatio={[[16, 9]]} />
      </div>
    ));
  };

  const getLoadMore = () => {
    return (
      <div onClick={handleReadMoreClick} style={{ cursor: "pointer" }}>
        <LoadmoreButton
          config={config}
          collection={collection}
          sectionSwitch={false}
          qtConfig={{}}
          isBtnWithArrow={true}
        />
      </div>
    );
  };

  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";

  return (
    <div>
      <div styleName="wrapper" className="full-width-with-padding arrow-component" data-test-id="lifestyle-row">
        <div styleName="lifestyle-row-wrapper">
          <div styleName="collection-name-with-read-more" onClick={handleCollectionNameClick}>
            <CollectionName
              collection={collection}
              collectionNameTemplate={collectionNameTemplate}
              collectionNameBorderColor={collectionNameBorderColor}
            />
            {isDesktop ? (
              page !== "author-page" && page !== "profile-page" && getLoadMore()
            ) : (
              <Link className="load-more-button" href={getSlug(collection, {})}>
                <SvgIconHandler type="read-more-arrow" width="18" height="18" viewBox="0 0 18 18" />
              </Link>
            )}
          </div>
          {/* Mobile Layout */}
          <div styleName="row-mobile">
            {stories[0] && (
              <div styleName="mobile-first-story" onClick={() => handleStoryClick(0)}>
                <StoryCard story={stories[0]} config={config} headerLevel={2} aspectRatio={[[16, 9]]} />
              </div>
            )}
            <div styleName="magazine-grid">
              {stories.slice(1, 5).map((story, idx) => (
                <div styleName="magazine-card" key={story.id || idx} onClick={() => handleStoryClick(idx)}>
                  <StoryCard story={story} config={config} headerLevel={5} aspectRatio={[[16, 9]]} />
                </div>
              ))}
            </div>
            <div styleName="read-more-button">
              <Button href={getSlug(collection, {})}>Read More</Button>
            </div>
          </div>

          {/* Desktop Layout */}
          <div styleName="row-desktop">
            <div styleName="desktop-top-row">{renderStoryCards(stories.slice(0, 2))}</div>
            <div styleName="desktop-bottom-row">{renderStoryCards(stories.slice(2, 5))}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

LifestyleRow.storyLimit = 5;

LifestyleRow.propTypes = {
  collection: PropTypes.object.isRequired,
  config: PropTypes.shape({
    collectionNameTemplate: PropTypes.string,
    collectionNameBorderColor: PropTypes.string,
  }),
  page: PropTypes.string,
};

export default LifestyleRow;
